// ABOUTME: Manages daily outfit suggestions with caching and acceptance tracking
// ABOUTME: Coordinates between suggestion store, wear log, and game stores

import { useWardrobeStore } from '@/lib/store/wardrobeStore'
import { useWearLogStore } from '@/lib/store/wearLogStore'
import { useGameStore } from '@/lib/store/gameStore'
import { useSuggestionStore, type SuggestedOutfit } from '@/lib/store/suggestionStore'
import { generateDailySuggestions } from '@/lib/utils/recommendations'
import { XP_REWARDS } from '@/constants/gamification'

function getToday(): string {
  return new Date().toISOString().split('T')[0]
}

export function getSuggestionsForToday(): SuggestedOutfit[] {
  const { todaysSuggestions, lastGeneratedDate, setSuggestions } = useSuggestionStore.getState()
  const today = getToday()

  if (todaysSuggestions && lastGeneratedDate === today) {
    return todaysSuggestions
  }

  const { items } = useWardrobeStore.getState()
  const { logs } = useWearLogStore.getState()

  const suggestions = generateDailySuggestions(items, logs, 3)
  setSuggestions(suggestions, today)

  return suggestions
}

export function acceptSuggestion(suggestion: SuggestedOutfit): void {
  const today = getToday()

  useWearLogStore.getState().logWear({
    date: today,
    itemIds: suggestion.items.map((i) => i.id),
    source: 'suggestion',
  })

  const gameStore = useGameStore.getState()
  gameStore.addExperience(XP_REWARDS.ACCEPT_SUGGESTION)
}

export function skipSuggestion(suggestion: SuggestedOutfit): void {
  const today = getToday()
  useSuggestionStore.getState().recordSkip(
    today,
    suggestion.items.map((i) => i.id)
  )
}
